import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import * as aa from "../../generated/UserAPIAgent";
import "./styles.scss";
import UserAction from "./UserAction";
import { Props } from "../../types/common";
import { PREFECTURES } from "../../generated/lib-domain/prefectures";
import { oneLink } from "../../shared/oneLink";

interface MyPagePageProps extends Props {
    user: aa.User;
    paymentStatus: aa.PaymentStatusObj | null;
    standardCardPaymentPlan: aa.CardPaymentPlan;
}

function changeMemberTypeLabel(isPaid: boolean): "有料会員" | "無料会員" {
    return isPaid ? "有料会員" : "無料会員";
}

function changePrefLabel(pref: number): string {
    const userPref = PREFECTURES.find((p) => p.id === pref);
    if (userPref === undefined) return "";
    return userPref.text;
}

const MyPage = (props: MyPagePageProps) => {
    return (
        <MainLayout>
            <Headline>{props.user.nickname + "さんの登録情報"}</Headline>
            <div className="myPage__user-info">
                <div className="myPage__avater-area">
                    {props.user.mainPhoto ? (
                        <img src={props.user.mainPhoto.medium} alt="avatar" />
                    ) : (
                        <div className="avatar-placeholder"></div>
                    )}
                </div>
                <div className="myPage__info-area">
                    <h2>{props.user.nickname}</h2>
                    <p>
                        {props.user.age +
                            "歳 / " +
                            changePrefLabel(props.user.userProfile.pref)}
                    </p>
                    <p>{changeMemberTypeLabel(props.user.isPaid)}</p>
                    <a
                        href={oneLink()}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="myPage__open-one-link"
                    >
                        アプリでプロフィールを確認・編集
                    </a>
                </div>
            </div>
            <div>
                <UserAction
                    status={props.user.status}
                    isPaid={props.user.isPaid}
                    paymentStatus={props.paymentStatus}
                    standardCardPaymentPlan={props.standardCardPaymentPlan}
                />
            </div>
        </MainLayout>
    );
};

export default MyPage;
